import { ReactNode } from "react";
import Badge, { BadgeProps } from "./Badge";

export const getBadge = ({ bgColor, text }: BadgeProps): ReactNode => {
  return <Badge bgColor={bgColor} text={text} />;
};
